import Vue from 'vue'
import config from '@/config/index'

export default {
  state: {
    roomItems: []
  },
  getters: {
    roomItems (state) {
      return state.roomItems
    }
  },
  mutations: {
    setRoomItems (state, payload) {
      state.roomItems = payload
    }
  },
  actions: {
    fetchRooms ({ commit, dispatch }, payload) {
      console.log('actions fetchRooms')
      Vue.axios.get(`${config.serverURI}/rooms`).then((response) => {
        // console.log('rooms', response.data)
        commit('setRoomItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error.response.data.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/room.js